import { APPLICATION_JSON } from "@/constans";
import { BACKEND_BASE_URL, IResponseError } from "@/services";
import {
  ISolService,
  IValidateSolClientParams,
  IValidateSolClientResponse,
  IValidateSolServicepointParams,
  IValidateSolServicepointResponse,
  IValidateSolSubclientParams,
  IValidateSolSubclientResponse,
} from "@/services/backend/sol/sol.types";
import { handleResponse } from "@/services/handlers";
import Vue from "vue";

export class SolService implements ISolService {
  async validateSolClient(
    countryCode: string,
    params: IValidateSolClientParams
  ): Promise<IValidateSolClientResponse | undefined> {
    const headers: Record<string, string> = {
      Accept: APPLICATION_JSON,
    };

    const { response, error } = await handleResponse<IValidateSolClientResponse, IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/sol/${countryCode}/v1/client`, {
        headers,
        params,
      })
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }
  async validateSolSubclient(
    countryCode: string,
    params: IValidateSolSubclientParams
  ): Promise<IValidateSolSubclientResponse | undefined> {
    const headers: Record<string, string> = {
      Accept: APPLICATION_JSON,
    };

    const { response, error } = await handleResponse<IValidateSolSubclientResponse, IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/sol/${countryCode}/v1/sub-client`, {
        headers,
        params,
      })
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }
  async validateSolServicepoint(
    countryCode: string,
    params: IValidateSolServicepointParams
  ): Promise<IValidateSolServicepointResponse | undefined> {
    const headers: Record<string, string> = {
      Accept: APPLICATION_JSON,
    };

    const { response, error } = await handleResponse<
      IValidateSolServicepointResponse,
      IResponseError
    >(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/sol/${countryCode}/v1/service-point`, {
        headers,
        params,
      })
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }
}
